import { render, staticRenderFns } from "./MasterDepartment.vue?vue&type=template&id=4255cf70&scoped=true&lang=pug&"
import script from "./scripts/MasterDepartment.js?vue&type=script&lang=js&"
export * from "./scripts/MasterDepartment.js?vue&type=script&lang=js&"
import style0 from "./MasterDepartment.vue?vue&type=style&index=0&id=4255cf70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4255cf70",
  null
  
)

export default component.exports